import API from '../../../services/api';

export const submitSendBudget = async (data) => {
    return await API.post('/budgets/sendemailcheckout', data)
        .then(res => res.data)
        .catch(error => error.message);
};
